import { api } from './api';

export type AnnotatedEvidenceStatus = 'ready' | 'empty' | 'processing' | 'error';

export type AnnotatedEvidencePrimaryMedia = 'image' | 'clip';

export interface AnnotatedEvidenceLatest {
  status: AnnotatedEvidenceStatus;
  camera_id: string;
  edge_device_id?: string;
  image_url?: string;
  image_review_role?: string;
  image_snapshot_overlay?: string;
  image_pre_annotated?: boolean;
  clip_url?: string;
  clip_source?: string;
  image_ready?: boolean;
  clip_ready?: boolean;
  primary_media_type?: AnnotatedEvidencePrimaryMedia | null;
  timestamp?: string;
  incident_id?: string;
  event_type?: string;
  zone?: string;
  confidence?: number;
  incident_subject_label?: string;
  trigger_person_verification_status?: string;
  trigger_person_verification_label?: string;
  clip_start_ts_ms?: number;
  clip_end_ts_ms?: number;
  clip_timing_basis?: string;
  clip_event_covered?: boolean | null;
  message?: string;
}

export async function getLatestAnnotatedEvidence(
  cameraId: string,
  edgeDeviceId?: string,
): Promise<AnnotatedEvidenceLatest> {
  const params: Record<string, string> = {};
  const deviceId = (edgeDeviceId || '').trim();
  if (deviceId) params.edge_device_id = deviceId;
  const { data } = await api.get<AnnotatedEvidenceLatest>(
    `/api/v1/cameras/${encodeURIComponent(cameraId)}/annotated-evidence/latest`,
    { params: Object.keys(params).length ? params : undefined },
  );
  return data;
}

export function annotatedEvidenceMediaPath(mediaUrl: string): string {
  const path = mediaUrl.startsWith('/') ? mediaUrl : `/${mediaUrl}`;
  return path.split('?')[0];
}

/** @deprecated direct media URLs fail in-browser (401 without JWT); use fetchAnnotatedEvidenceMediaBlob */
export function annotatedEvidenceMediaSrc(mediaUrl: string): string {
  const base = typeof window !== 'undefined' ? window.location.origin : '';
  return `${base}${annotatedEvidenceMediaPath(mediaUrl)}`;
}

export async function fetchAnnotatedEvidenceMediaBlob(mediaUrl: string): Promise<Blob> {
  const path = annotatedEvidenceMediaPath(mediaUrl);
  const { data } = await api.get<Blob>(path, { responseType: 'blob' });
  return data;
}

/** @deprecated use annotatedEvidenceMediaSrc */
export function annotatedEvidenceImageSrc(imageUrl: string): string {
  return annotatedEvidenceMediaSrc(imageUrl);
}
